import { motion, useReducedMotion } from "framer-motion";

// Infinite brand-mark marquee: official logos sliding past like a ticker.
export const BrandMarquee = ({ className = "", testid = "brand-marquee" }) => {
  const reduce = useReducedMotion();
  const items = [
    { src: "/brands/apple.svg", name: "Apple" },
    { src: "/brands/samsung.svg", name: "Samsung" },
    { src: "/brands/google.svg", name: "Google" },
  ];
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid={testid}
      aria-hidden="true"
      className={`overflow-hidden border-y border-sand/60 py-4 ${className}`}
      style={{
        WebkitMaskImage: "linear-gradient(90deg, transparent, #000 12%, #000 88%, transparent)",
        maskImage: "linear-gradient(90deg, transparent, #000 12%, #000 88%, transparent)",
      }}
    >
      <div className={`flex w-max items-center gap-16 ${reduce ? "" : "animate-marquee"}`}>
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-16">
            {row.map((b, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-3 opacity-70">
                <motion.img
                  src={b.src}
                  alt=""
                  className={b.name === "Samsung" ? "h-4 w-auto" : "h-5 w-auto"}
                  animate={reduce ? {} : { y: [0, -3, 0] }}
                  transition={{ duration: 3 + (i % 3), repeat: Infinity, ease: "easeInOut" }}
                />
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink/50">{b.name}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
